// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-header[data-v-2ba4d647] {\n  margin: 18px 0;\n}\n.delBtn[data-v-2ba4d647] {\n  color: #ff6e55e6 !important;\n}\n", ""]);
// Exports
module.exports = exports;
